import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";

export default function Layout() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-[#f6f7f9]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto bhf-scrollbar">
        <Outlet />
      </main>
    </div>
  );
}
